import React, { useState } from "react";
import { ProfitTab, MonthPicker } from "../../components/commissions/ProfitTab";
import { NetworksTab } from "../../components/commissions/NetworksTab";
import { PeopleTab } from "../../components/commissions/PeopleTab";
import { LedgerTab, StatementsTab } from "../../components/commissions/LedgerTabs";
import { SettingsTab } from "../../components/commissions/SettingsTab";
import { thisMonth } from "../../components/commissions/api";

const TABS = [["profit", "Profitability"], ["networks", "Networks"], ["people", "Affiliates & Partners"], ["ledger", "Ledger"], ["statements", "Statements & payouts"], ["settings", "Settings"]];

export default function AdminCommissions() {
  const [tab, setTab] = useState("profit");
  const [ym, setYm] = useState(thisMonth());
  return (
    <div className="min-h-screen bg-[#fbfaf6] px-5 py-10 text-[#2b2b2b] sm:px-8" data-testid="admin-commissions-page">
      <h1 className="text-3xl text-[#2b2b2b] sm:text-4xl" style={{ fontFamily: '"Cormorant Garamond", Georgia, serif' }}>Commissions & profitability</h1>
      <div className="mt-5 flex flex-wrap items-center gap-2">
        {TABS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`commissions-tab-${k}`}
            className={`rounded-full px-4 py-1.5 text-sm transition-colors ${tab === k ? "bg-[#2b2b2b] text-white" : "border border-[#e5e0d3] bg-white hover:bg-[#f3efe4]"}`}>{l}</button>
        ))}
        {["profit", "ledger", "statements"].includes(tab) && <div className="ml-auto"><MonthPicker ym={ym} setYm={setYm} /></div>}
      </div>
      <div className="mt-6">
        {tab === "profit" && <ProfitTab ym={ym} />}
        {tab === "networks" && <NetworksTab />}
        {tab === "people" && <PeopleTab />}
        {tab === "ledger" && <LedgerTab ym={ym} />}
        {tab === "statements" && <StatementsTab ym={ym} />}
        {tab === "settings" && <SettingsTab />}
      </div>
    </div>
  );
}
